import axios from "axios";
import { notification } from "antd";

const baseUrl =
  window.location.hostname === "localhost"
    ? "http://127.0.0.1:5000/api"
    : "https://posthog-backend-63rx.onrender.com/api";

const axiosClient = axios.create({
  baseURL: baseUrl,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const message = error.response?.data?.message || error.message;
    notification.error({
      message: "Error",
      description: message,
      duration: 5,
    });

    return Promise.reject(error);
  },
);

export default axiosClient;
